{
  "schemaVersion": 1,
  "defaultTheme": "default",
  "hierarchyDefaults": {
    "coreNodeWeight": 0.56,
    "coreBorderWeight": 0.72,
    "detailNodeWeight": 0.76,
    "detailBorderWeight": 0.68
  },
  "visualDefaults": {
    "nodeStyle": {
      "focalRadius": 10,
      "coreRadius": 8,
      "supportingRadius": 6,
      "detailRadius": 4,
      "borderWidthScale": 1
    },
    "edgeStyle": {
      "widthScale": 1,
      "opacity": 1,
      "markerScale": 1
    },
    "relationshipLabelStyle": {
      "fontSize": 12,
      "fontWeight": 400,
      "opacity": 1,
      "haloPadding": 2.5,
      "haloOpacity": 0,
      "offset": 0
    },
    "typography": {
      "focalWeight": 800,
      "coreWeight": 700,
      "supportingWeight": 500,
      "detailWeight": 400
    },
    "gridStyle": {
      "type": "dots",
      "opacity": 1,
      "spacing": 16
    }
  },
  "visualPresets": {
    "classic": {
      "nodeStyle": {
        "focalRadius": 9,
        "coreRadius": 7,
        "supportingRadius": 6,
        "detailRadius": 4,
        "borderWidthScale": 1
      },
      "edgeStyle": {
        "widthScale": 0.95,
        "opacity": 0.86,
        "markerScale": 0.98
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 500,
        "opacity": 0.92,
        "haloPadding": 2.5,
        "haloOpacity": 0.9,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.28,
        "spacing": 20
      }
    },
    "accessible": {
      "nodeStyle": {
        "focalRadius": 8,
        "coreRadius": 7,
        "supportingRadius": 6,
        "detailRadius": 4,
        "borderWidthScale": 1.15
      },
      "edgeStyle": {
        "widthScale": 1.08,
        "opacity": 0.96,
        "markerScale": 1.05
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 1,
        "haloPadding": 3,
        "haloOpacity": 1,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.34,
        "spacing": 18
      }
    },
    "paper-soft": {
      "nodeStyle": {
        "focalRadius": 12,
        "coreRadius": 9,
        "supportingRadius": 7,
        "detailRadius": 5,
        "borderWidthScale": 0.88
      },
      "edgeStyle": {
        "widthScale": 0.8,
        "opacity": 0.74,
        "markerScale": 0.9
      },
      "relationshipLabelStyle": {
        "fontSize": 11,
        "fontWeight": 500,
        "opacity": 0.88,
        "haloPadding": 2,
        "haloOpacity": 0.88,
        "offset": 1
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.12,
        "spacing": 24
      }
    },
    "graphic": {
      "nodeStyle": {
        "focalRadius": 4,
        "coreRadius": 3,
        "supportingRadius": 2,
        "detailRadius": 1,
        "borderWidthScale": 1.18
      },
      "edgeStyle": {
        "widthScale": 1.22,
        "opacity": 0.94,
        "markerScale": 1.08
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 0.98,
        "haloPadding": 3,
        "haloOpacity": 0.95,
        "offset": 0
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 800,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "lines",
        "opacity": 0.22,
        "spacing": 24
      }
    },
    "luminous": {
      "nodeStyle": {
        "focalRadius": 14,
        "coreRadius": 11,
        "supportingRadius": 9,
        "detailRadius": 7,
        "borderWidthScale": 0.96
      },
      "edgeStyle": {
        "widthScale": 0.98,
        "opacity": 0.76,
        "markerScale": 0.98
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 500,
        "opacity": 0.9,
        "haloPadding": 3.25,
        "haloOpacity": 0.96,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.26,
        "spacing": 22
      }
    },
    "technical": {
      "nodeStyle": {
        "focalRadius": 5,
        "coreRadius": 4,
        "supportingRadius": 3,
        "detailRadius": 2,
        "borderWidthScale": 1.04
      },
      "edgeStyle": {
        "widthScale": 0.94,
        "opacity": 0.86,
        "markerScale": 0.98
      },
      "relationshipLabelStyle": {
        "fontSize": 11,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 2.5,
        "haloOpacity": 0.94,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "cross",
        "opacity": 0.34,
        "spacing": 20
      }
    },
    "studio": {
      "nodeStyle": {
        "focalRadius": 10,
        "coreRadius": 8,
        "supportingRadius": 6,
        "detailRadius": 4,
        "borderWidthScale": 0.92
      },
      "edgeStyle": {
        "widthScale": 0.86,
        "opacity": 0.74,
        "markerScale": 0.94
      },
      "relationshipLabelStyle": {
        "fontSize": 11,
        "fontWeight": 500,
        "opacity": 0.88,
        "haloPadding": 2.25,
        "haloOpacity": 0.9,
        "offset": 1
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.18,
        "spacing": 22
      }
    },
    "organic": {
      "nodeStyle": {
        "focalRadius": 16,
        "coreRadius": 13,
        "supportingRadius": 10,
        "detailRadius": 8,
        "borderWidthScale": 0.94
      },
      "edgeStyle": {
        "widthScale": 0.9,
        "opacity": 0.8,
        "markerScale": 0.96
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 500,
        "opacity": 0.9,
        "haloPadding": 2.75,
        "haloOpacity": 0.92,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.2,
        "spacing": 24
      }
    },
    "playful": {
      "nodeStyle": {
        "focalRadius": 18,
        "coreRadius": 15,
        "supportingRadius": 12,
        "detailRadius": 9,
        "borderWidthScale": 1.04
      },
      "edgeStyle": {
        "widthScale": 1.08,
        "opacity": 0.86,
        "markerScale": 1.02
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 3,
        "haloOpacity": 0.94,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.24,
        "spacing": 20
      }
    },
    "arcade": {
      "nodeStyle": {
        "focalRadius": 3,
        "coreRadius": 3,
        "supportingRadius": 2,
        "detailRadius": 2,
        "borderWidthScale": 1.12
      },
      "edgeStyle": {
        "widthScale": 1.18,
        "opacity": 0.9,
        "markerScale": 1.08
      },
      "relationshipLabelStyle": {
        "fontSize": 11,
        "fontWeight": 600,
        "opacity": 0.96,
        "haloPadding": 3,
        "haloOpacity": 0.96,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 800,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "cross",
        "opacity": 0.3,
        "spacing": 18
      }
    },
    "minimal": {
      "nodeStyle": {
        "focalRadius": 2,
        "coreRadius": 1,
        "supportingRadius": 1,
        "detailRadius": 0,
        "borderWidthScale": 0.82
      },
      "edgeStyle": {
        "widthScale": 0.72,
        "opacity": 0.68,
        "markerScale": 0.86
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 500,
        "opacity": 0.86,
        "haloPadding": 1.5,
        "haloOpacity": 0.82,
        "offset": 0
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 24
      }
    },
    "cloud": {
      "nodeStyle": {
        "focalRadius": 20,
        "coreRadius": 17,
        "supportingRadius": 13,
        "detailRadius": 10,
        "borderWidthScale": 0.72
      },
      "edgeStyle": {
        "widthScale": 0.78,
        "opacity": 0.66,
        "markerScale": 0.9
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 500,
        "opacity": 0.88,
        "haloPadding": 3.5,
        "haloOpacity": 0.94,
        "offset": 3
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.12,
        "spacing": 28
      }
    },
    "systems": {
      "nodeStyle": {
        "focalRadius": 18,
        "coreRadius": 9,
        "supportingRadius": 4,
        "detailRadius": 1,
        "borderWidthScale": 1.1
      },
      "edgeStyle": {
        "widthScale": 1.08,
        "opacity": 0.9,
        "markerScale": 1.02
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 600,
        "opacity": 0.96,
        "haloPadding": 2,
        "haloOpacity": 0.96,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 28
      }
    }
  },
  "groups": [
    {
      "id": "foundations",
      "name": "Clarity & accessibility"
    },
    {
      "id": "expressive",
      "name": "Expressive & presentation"
    },
    {
      "id": "professional",
      "name": "Professional & editorial"
    },
    {
      "id": "natural",
      "name": "Natural & reflective"
    },
    {
      "id": "playful",
      "name": "Playful & energetic"
    }
  ],
  "themes": [
    {
      "id": "default",
      "visualPreset": "classic",
      "name": "Classic",
      "group": "foundations",
      "description": "Clean neutral styling for everyday knowledge maps",
      "palette": [
        "#40566f",
        "#65758b",
        "#526879",
        "#7b8794"
      ],
      "background": "#fbfbfa",
      "grid": "#e8e9e7",
      "node": "#ffffff",
      "nodeBorder": "#7b8794",
      "text": "#171a1f",
      "focalNode": "#edf1f5",
      "focalBorder": "#30465e",
      "coreNode": "#f7f8f8",
      "coreBorder": "#566575",
      "detailNode": "#ffffff",
      "detailBorder": "#89939e",
      "labelHalo": "#fbfbfa",
      "canvas": "dual",
      "access": "free"
    },
    {
      "id": "accessible",
      "visualPreset": "accessible",
      "name": "Accessible",
      "group": "foundations",
      "description": "Color-vision-safe categorical colors with strong structural contrast",
      "palette": [
        "#0072b2",
        "#d55e00",
        "#009e73",
        "#cc79a7",
        "#56b4e9",
        "#e69f00",
        "#5b4ab8",
        "#6b625b"
      ],
      "background": "#ffffff",
      "grid": "#e4e7eb",
      "node": "#ffffff",
      "nodeBorder": "#455260",
      "text": "#111820",
      "focalNode": "#e8f1f5",
      "focalBorder": "#182532",
      "coreNode": "#f8fafb",
      "coreBorder": "#425466",
      "detailNode": "#ffffff",
      "detailBorder": "#6b7785",
      "labelHalo": "#ffffff",
      "canvas": "paper",
      "access": "free"
    },
    {
      "id": "high-contrast",
      "visualPreset": "accessible",
      "name": "High Contrast",
      "group": "foundations",
      "description": "Hard contrast and distinct relationship colors for projection and low-vision use",
      "palette": [
        "#005fcc",
        "#c62828",
        "#007a4d",
        "#6a35c7",
        "#a84d00",
        "#007c91",
        "#ad176d",
        "#111111"
      ],
      "background": "#ffffff",
      "grid": "#d9dde1",
      "node": "#ffffff",
      "nodeBorder": "#111111",
      "text": "#000000",
      "focalNode": "#ffffff",
      "focalBorder": "#111111",
      "coreNode": "#f2f2f2",
      "coreBorder": "#111111",
      "detailNode": "#ffffff",
      "detailBorder": "#333333",
      "labelHalo": "#ffffff",
      "canvas": "paper",
      "access": "free"
    },
    {
      "id": "minimal",
      "visualPreset": "minimal",
      "name": "Minimal",
      "group": "foundations",
      "description": "Ultra-clean contemporary structure with quiet blue-gray accents",
      "palette": [
        "#0f172a",
        "#334155",
        "#64748b",
        "#0f766e",
        "#2563eb"
      ],
      "background": "#fcfcfd",
      "grid": "#edf0f2",
      "node": "#ffffff",
      "nodeBorder": "#a1a8b0",
      "text": "#15181c",
      "focalNode": "#f4f6f8",
      "focalBorder": "#39414a",
      "coreNode": "#fafbfc",
      "coreBorder": "#76808a",
      "detailNode": "#ffffff",
      "detailBorder": "#b0b6bd",
      "labelHalo": "#fcfcfd",
      "canvas": "paper",
      "access": "free"
    },
    {
      "id": "focus",
      "nodeStyle": {
        "focalRadius": 5,
        "coreRadius": 4,
        "supportingRadius": 3,
        "detailRadius": 2,
        "borderWidthScale": 0.96
      },
      "edgeStyle": {
        "widthScale": 0.88,
        "opacity": 0.88,
        "markerScale": 0.94
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 600,
        "opacity": 0.96,
        "haloPadding": 2,
        "haloOpacity": 0.96,
        "offset": 0
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 24
      },
      "name": "Focus",
      "group": "foundations",
      "description": "Compact high-legibility styling for dense and information-rich maps",
      "palette": [
        "#24527a",
        "#2f6f68",
        "#75538c",
        "#9a5a36",
        "#536b3d",
        "#596778",
        "#9a4560"
      ],
      "background": "#fbfcfd",
      "grid": "#e9edf0",
      "node": "#ffffff",
      "nodeBorder": "#6f7b86",
      "text": "#18212a",
      "focalNode": "#eaf0f5",
      "focalBorder": "#31536d",
      "coreNode": "#f5f7f9",
      "coreBorder": "#667786",
      "detailNode": "#ffffff",
      "detailBorder": "#8d979f",
      "labelHalo": "#fbfcfd",
      "canvas": "paper",
      "access": "free"
    },
    {
      "id": "slate",
      "nodeStyle": {
        "focalRadius": 7,
        "coreRadius": 6,
        "supportingRadius": 4,
        "detailRadius": 3,
        "borderWidthScale": 1
      },
      "edgeStyle": {
        "widthScale": 0.88,
        "opacity": 0.84,
        "markerScale": 0.94
      },
      "relationshipLabelStyle": {
        "fontSize": 11,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 2.5,
        "haloOpacity": 0.96,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.18,
        "spacing": 22
      },
      "name": "Slate",
      "group": "foundations",
      "description": "Neutral dark-mode styling with clear structure and restrained categorical color",
      "palette": [
        "#78a9d1",
        "#63b3a6",
        "#c99b5b",
        "#9e8ac7",
        "#d27a78",
        "#82a56a",
        "#93a0ad"
      ],
      "background": "#171b20",
      "grid": "#313840",
      "node": "#222830",
      "nodeBorder": "#7b8793",
      "text": "#f4f6f8",
      "focalNode": "#2b3540",
      "focalBorder": "#78a9d1",
      "coreNode": "#242c34",
      "coreBorder": "#8493a1",
      "detailNode": "#1d232a",
      "detailBorder": "#65717c",
      "labelHalo": "#171b20",
      "canvas": "dark",
      "access": "free"
    },
    {
      "id": "underground",
      "nodeStyle": {
        "focalRadius": 9,
        "coreRadius": 7,
        "supportingRadius": 5,
        "detailRadius": 3,
        "borderWidthScale": 1.08
      },
      "edgeStyle": {
        "widthScale": 1.35,
        "opacity": 0.92,
        "markerScale": 1.08
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 0.96,
        "haloPadding": 3.25,
        "haloOpacity": 0.92,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "lines",
        "opacity": 0.18,
        "spacing": 24
      },
      "name": "Underground",
      "group": "foundations",
      "description": "Transit-map color with strong linear structure and restrained station-like geometry",
      "palette": [
        "#e42313",
        "#0019a8",
        "#007d32",
        "#ffc80a",
        "#9b0058",
        "#039be5",
        "#b26300",
        "#838d93",
        "#76d0bd",
        "#f589a6",
        "#000000"
      ],
      "background": "#f8f8f6",
      "grid": "#e1e1dd",
      "node": "#ffffff",
      "nodeBorder": "#343434",
      "text": "#111111",
      "focalNode": "#ffffff",
      "focalBorder": "#0019a8",
      "coreNode": "#ffffff",
      "coreBorder": "#343434",
      "detailNode": "#ffffff",
      "detailBorder": "#686868",
      "labelHalo": "#ffffff",
      "canvas": "paper",
      "access": "free"
    },
    {
      "id": "ink",
      "nodeStyle": {
        "focalRadius": 5,
        "coreRadius": 4,
        "supportingRadius": 3,
        "detailRadius": 2,
        "borderWidthScale": 0.9
      },
      "edgeStyle": {
        "widthScale": 0.76,
        "opacity": 0.8,
        "markerScale": 0.88
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 500,
        "opacity": 0.88,
        "haloPadding": 1.5,
        "haloOpacity": 0.84,
        "offset": 0
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 24
      },
      "name": "Ink",
      "group": "foundations",
      "description": "Monochrome hierarchy for print, research, and formal diagrams",
      "palette": [
        "#111111",
        "#343434",
        "#555555",
        "#737373",
        "#929292"
      ],
      "background": "#fdfdfc",
      "grid": "#e7e7e5",
      "node": "#ffffff",
      "nodeBorder": "#454545",
      "text": "#111111",
      "focalNode": "#ffffff",
      "focalBorder": "#161616",
      "coreNode": "#eeeeec",
      "coreBorder": "#333333",
      "detailNode": "#ffffff",
      "detailBorder": "#707070",
      "labelHalo": "#fdfdfc",
      "canvas": "paper",
      "access": "free"
    },
    {
      "id": "paper",
      "visualPreset": "paper-soft",
      "name": "Paper",
      "group": "foundations",
      "description": "Soft off-white paper with restrained graphite and blue-gray structure",
      "palette": [
        "#3e4954",
        "#61707c",
        "#405d72",
        "#6d625d",
        "#536b62",
        "#7a7380"
      ],
      "background": "#f7f5f0",
      "grid": "#e4e0d8",
      "node": "#fffefa",
      "nodeBorder": "#686762",
      "text": "#242424",
      "focalNode": "#ece9e2",
      "focalBorder": "#343a40",
      "coreNode": "#f4f2ed",
      "coreBorder": "#656965",
      "detailNode": "#fffefa",
      "detailBorder": "#898984",
      "labelHalo": "#f7f5f0",
      "canvas": "paper",
      "access": "free"
    },
    {
      "id": "bauhaus",
      "nodeStyle": {
        "focalRadius": 3,
        "coreRadius": 2,
        "supportingRadius": 2,
        "detailRadius": 1,
        "borderWidthScale": 1.2
      },
      "edgeStyle": {
        "widthScale": 1.25,
        "opacity": 0.94,
        "markerScale": 1.08
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 0.98,
        "haloPadding": 3,
        "haloOpacity": 0.94,
        "offset": 0
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 800,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "lines",
        "opacity": 0.26,
        "spacing": 24
      },
      "name": "Bauhaus",
      "group": "expressive",
      "description": "Primary color, black structure, and warm white for bold graphic explanatory maps",
      "palette": [
        "#d62828",
        "#1756a9",
        "#e3ad16",
        "#111111",
        "#13805b"
      ],
      "background": "#f7f4eb",
      "grid": "#dfdbcf",
      "node": "#fffdf7",
      "nodeBorder": "#111111",
      "text": "#111111",
      "focalNode": "#e3ad16",
      "focalBorder": "#111111",
      "coreNode": "#fffdf7",
      "coreBorder": "#111111",
      "detailNode": "#fffdf7",
      "detailBorder": "#3f3f3f",
      "labelHalo": "#f7f4eb",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "aurora",
      "visualPreset": "luminous",
      "nodeStyle": {
        "focalRadius": 16,
        "coreRadius": 12,
        "supportingRadius": 9,
        "detailRadius": 7,
        "borderWidthScale": 0.9
      },
      "edgeStyle": {
        "widthScale": 0.96,
        "opacity": 0.72,
        "markerScale": 0.96
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 500,
        "opacity": 0.9,
        "haloPadding": 3.5,
        "haloOpacity": 0.97,
        "offset": 2
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.2,
        "spacing": 24
      },
      "name": "Aurora",
      "group": "expressive",
      "description": "Luminous cyan, green, violet, and rose on a deep night field",
      "palette": [
        "#45e0e8",
        "#74e68c",
        "#f27bb5",
        "#9d82ff",
        "#ffd257",
        "#5aafff",
        "#ff816e",
        "#53d6b5"
      ],
      "background": "#101522",
      "grid": "#2b3346",
      "node": "#191f30",
      "nodeBorder": "#8793aa",
      "text": "#f8f9fc",
      "focalNode": "#292349",
      "focalBorder": "#9d82ff",
      "coreNode": "#1d2939",
      "coreBorder": "#55c9d2",
      "detailNode": "#161c29",
      "detailBorder": "#647187",
      "labelHalo": "#101522",
      "canvas": "dual",
      "paperOverride": {
        "palette": [
          "#007f8a",
          "#24803d",
          "#b82d71",
          "#6947c6",
          "#987100",
          "#1972b8",
          "#c4493b",
          "#16806c"
        ],
        "background": "#ffffff",
        "grid": "#e1e5e8",
        "node": "#ffffff",
        "nodeBorder": "#5f6875",
        "text": "#171b22",
        "focalNode": "#eee8ff",
        "focalBorder": "#6947c6",
        "coreNode": "#f4f6f8",
        "coreBorder": "#667180",
        "detailNode": "#ffffff",
        "detailBorder": "#8b939c",
        "labelHalo": "#ffffff"
      },
      "access": "professional"
    },
    {
      "id": "neon-night",
      "visualPreset": "arcade",
      "nodeStyle": {
        "focalRadius": 10,
        "coreRadius": 8,
        "supportingRadius": 6,
        "detailRadius": 4,
        "borderWidthScale": 0.98
      },
      "edgeStyle": {
        "widthScale": 1.06,
        "opacity": 0.82,
        "markerScale": 1
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 3.5,
        "haloOpacity": 0.97,
        "offset": 2
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.12,
        "spacing": 26
      },
      "name": "Neon Night",
      "group": "expressive",
      "description": "Fluorescent cyan, pink, lime, and violet on aubergine with spacious nightlife-editorial structure",
      "palette": [
        "#19e6cf",
        "#ff4f9a",
        "#a6ed27",
        "#ffc928",
        "#4aa3ff",
        "#bd73ff",
        "#ff704d",
        "#31d6ff"
      ],
      "background": "#140d1c",
      "grid": "#392846",
      "node": "#21142e",
      "nodeBorder": "#967da8",
      "text": "#fffaff",
      "focalNode": "#351447",
      "focalBorder": "#ff4f9a",
      "coreNode": "#261934",
      "coreBorder": "#bd73ff",
      "detailNode": "#1d1228",
      "detailBorder": "#725d82",
      "labelHalo": "#140d1c",
      "canvas": "dual",
      "paperOverride": {
        "palette": [
          "#00877c",
          "#bd2468",
          "#587c00",
          "#946900",
          "#1768ac",
          "#7826b8",
          "#c64124",
          "#007c9e"
        ],
        "background": "#ffffff",
        "grid": "#e5dfe8",
        "node": "#ffffff",
        "nodeBorder": "#5c5063",
        "text": "#211829",
        "focalNode": "#f5deed",
        "focalBorder": "#ae205f",
        "coreNode": "#f7f2f8",
        "coreBorder": "#745d7f",
        "detailNode": "#ffffff",
        "detailBorder": "#918497",
        "labelHalo": "#ffffff"
      },
      "access": "professional",
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      }
    },
    {
      "id": "on-brand",
      "visualPreset": "classic",
      "nodeStyle": {
        "focalRadius": 14,
        "coreRadius": 10,
        "supportingRadius": 7,
        "detailRadius": 5,
        "borderWidthScale": 1
      },
      "edgeStyle": {
        "widthScale": 1.08,
        "opacity": 0.86,
        "markerScale": 1.02
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 2.75,
        "haloOpacity": 0.92,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.24,
        "spacing": 20
      },
      "name": "On Brand",
      "group": "expressive",
      "description": "KnowMapped electric green, cyan, magenta, violet, yellow, and orange",
      "palette": [
        "#4a9000",
        "#008aa3",
        "#c218a5",
        "#7f26c9",
        "#8c7200",
        "#cf4a00"
      ],
      "background": "#f8f8f6",
      "grid": "#e0e2dc",
      "node": "#ffffff",
      "nodeBorder": "#5b626d",
      "text": "#12131a",
      "focalNode": "#efffcf",
      "focalBorder": "#4a9000",
      "coreNode": "#d9faff",
      "coreBorder": "#008aa3",
      "detailNode": "#fbfcf8",
      "detailBorder": "#76806f",
      "labelHalo": "#ffffff",
      "canvas": "dual",
      "access": "professional",
      "coreLevelNode": "#d9faff",
      "coreLevelBorder": "#008aa3"
    },
    {
      "id": "spectrum",
      "nodeStyle": {
        "focalRadius": 14,
        "coreRadius": 11,
        "supportingRadius": 8,
        "detailRadius": 5,
        "borderWidthScale": 0.9
      },
      "edgeStyle": {
        "widthScale": 0.96,
        "opacity": 0.78,
        "markerScale": 0.96
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 500,
        "opacity": 0.92,
        "haloPadding": 3,
        "haloOpacity": 0.9,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.16,
        "spacing": 24
      },
      "name": "Spectrum",
      "group": "expressive",
      "description": "A smooth green-to-blue-to-violet spectrum on a quiet neutral field",
      "palette": [
        "#789949",
        "#589c68",
        "#3d987f",
        "#288fa0",
        "#347ab8",
        "#4763c2",
        "#5d49c6",
        "#7837c2"
      ],
      "background": "#fcfbfa",
      "grid": "#e4e5e6",
      "node": "#ffffff",
      "nodeBorder": "#687078",
      "text": "#17191c",
      "focalNode": "#eef0f3",
      "focalBorder": "#5d49c6",
      "coreNode": "#f6f7f8",
      "coreBorder": "#737b86",
      "detailNode": "#ffffff",
      "detailBorder": "#8b9197",
      "labelHalo": "#fcfbfa",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "signal",
      "visualPreset": "technical",
      "nodeStyle": {
        "focalRadius": 3,
        "coreRadius": 2,
        "supportingRadius": 2,
        "detailRadius": 1,
        "borderWidthScale": 1.12
      },
      "edgeStyle": {
        "widthScale": 1.1,
        "opacity": 0.92,
        "markerScale": 1.04
      },
      "relationshipLabelStyle": {
        "fontSize": 11,
        "fontWeight": 600,
        "opacity": 0.96,
        "haloPadding": 2.5,
        "haloOpacity": 0.96,
        "offset": 0
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "cross",
        "opacity": 0.26,
        "spacing": 22
      },
      "name": "Signal",
      "group": "expressive",
      "description": "Sharp information-design colors on a minimal white field",
      "palette": [
        "#006cff",
        "#e83b32",
        "#00a37a",
        "#f1b900",
        "#7c3aed",
        "#00a7c4",
        "#ee4f9b",
        "#161616"
      ],
      "background": "#ffffff",
      "grid": "#e8eaed",
      "node": "#ffffff",
      "nodeBorder": "#474747",
      "text": "#111111",
      "focalNode": "#eef4ff",
      "focalBorder": "#006cff",
      "coreNode": "#f7f8fa",
      "coreBorder": "#5f6873",
      "detailNode": "#ffffff",
      "detailBorder": "#8a9097",
      "labelHalo": "#ffffff",
      "canvas": "paper",
      "access": "professional"
    },
    {
      "id": "poster",
      "visualPreset": "graphic",
      "nodeStyle": {
        "focalRadius": 8,
        "coreRadius": 6,
        "supportingRadius": 4,
        "detailRadius": 2,
        "borderWidthScale": 1.12
      },
      "edgeStyle": {
        "widthScale": 1.16,
        "opacity": 0.9,
        "markerScale": 1.04
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 0.95,
        "haloPadding": 3.25,
        "haloOpacity": 0.94,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "lines",
        "opacity": 0.12,
        "spacing": 28
      },
      "name": "Poster",
      "group": "expressive",
      "description": "Flat poster colors, strong relationships, and warm white space",
      "palette": [
        "#f04438",
        "#2563eb",
        "#f59e0b",
        "#0f9f7f",
        "#9333ea",
        "#e53e8b",
        "#111111"
      ],
      "background": "#faf8f2",
      "grid": "#e6e1d7",
      "node": "#fffefa",
      "nodeBorder": "#262626",
      "text": "#171717",
      "focalNode": "#ffe7b0",
      "focalBorder": "#111111",
      "coreNode": "#fffefa",
      "coreBorder": "#404040",
      "detailNode": "#fffefa",
      "detailBorder": "#77736d",
      "labelHalo": "#faf8f2",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "bloom",
      "nodeStyle": {
        "focalRadius": 18,
        "coreRadius": 14,
        "supportingRadius": 10,
        "detailRadius": 7,
        "borderWidthScale": 0.88
      },
      "edgeStyle": {
        "widthScale": 0.92,
        "opacity": 0.8,
        "markerScale": 0.96
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 500,
        "opacity": 0.92,
        "haloPadding": 3.25,
        "haloOpacity": 0.94,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.12,
        "spacing": 28
      },
      "name": "Bloom",
      "group": "expressive",
      "description": "Spacious contemporary color with generous forms and refined editorial energy",
      "palette": [
        "#c23c69",
        "#d85c3f",
        "#315fba",
        "#27856b",
        "#c39218",
        "#8552b8",
        "#238d9c"
      ],
      "background": "#fffaf7",
      "grid": "#eee3de",
      "node": "#ffffff",
      "nodeBorder": "#8b767d",
      "text": "#2b2024",
      "focalNode": "#f8dce7",
      "focalBorder": "#b43f68",
      "coreNode": "#fdf0f4",
      "coreBorder": "#a76c83",
      "detailNode": "#ffffff",
      "detailBorder": "#a49399",
      "labelHalo": "#fffaf7",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "pulse",
      "nodeStyle": {
        "focalRadius": 10,
        "coreRadius": 7,
        "supportingRadius": 4,
        "detailRadius": 2,
        "borderWidthScale": 1.04
      },
      "edgeStyle": {
        "widthScale": 1.18,
        "opacity": 0.91,
        "markerScale": 1.06
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 600,
        "opacity": 0.96,
        "haloPadding": 3,
        "haloOpacity": 0.96,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 28
      },
      "name": "Pulse",
      "group": "expressive",
      "description": "High-energy contemporary presentation styling with bold scale, strong relationships, and clean visual rhythm",
      "palette": [
        "#2458e6",
        "#d63c3c",
        "#008f7a",
        "#db7a18",
        "#8049cf",
        "#c92f79",
        "#0087a8"
      ],
      "background": "#fdfdfd",
      "grid": "#e8eaed",
      "node": "#ffffff",
      "nodeBorder": "#444b55",
      "text": "#17191d",
      "focalNode": "#e9efff",
      "focalBorder": "#2458e6",
      "coreNode": "#f6f7fa",
      "coreBorder": "#586575",
      "detailNode": "#ffffff",
      "detailBorder": "#858d97",
      "labelHalo": "#fdfdfd",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "editorial",
      "nodeStyle": {
        "focalRadius": 6,
        "coreRadius": 5,
        "supportingRadius": 4,
        "detailRadius": 3,
        "borderWidthScale": 0.88
      },
      "edgeStyle": {
        "widthScale": 0.8,
        "opacity": 0.74,
        "markerScale": 0.9
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 500,
        "opacity": 0.88,
        "haloPadding": 1.75,
        "haloOpacity": 0.86,
        "offset": 1
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "lines",
        "opacity": 0.1,
        "spacing": 28
      },
      "name": "Editorial",
      "group": "professional",
      "description": "Contemporary publishing colors with crisp ink and restrained accents",
      "palette": [
        "#202124",
        "#d05a43",
        "#275dad",
        "#27806a",
        "#9b4f7a",
        "#c68a2d"
      ],
      "background": "#faf9f6",
      "grid": "#e7e3dd",
      "node": "#ffffff",
      "nodeBorder": "#66635f",
      "text": "#202124",
      "focalNode": "#e8e4de",
      "focalBorder": "#202124",
      "coreNode": "#f5f3ef",
      "coreBorder": "#716d67",
      "detailNode": "#ffffff",
      "detailBorder": "#96918a",
      "labelHalo": "#faf9f6",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "blueprint",
      "nodeStyle": {
        "focalRadius": 4,
        "coreRadius": 3,
        "supportingRadius": 3,
        "detailRadius": 2,
        "borderWidthScale": 1.05
      },
      "edgeStyle": {
        "widthScale": 0.96,
        "opacity": 0.88,
        "markerScale": 0.98
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 600,
        "opacity": 0.96,
        "haloPadding": 2.5,
        "haloOpacity": 0.95,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "cross",
        "opacity": 0.38,
        "spacing": 20
      },
      "name": "Blueprint",
      "group": "professional",
      "description": "Cobalt, cyan, and technical blue for frameworks and systems",
      "palette": [
        "#1557c0",
        "#0087a8",
        "#2446a8",
        "#147d77",
        "#6372c5",
        "#286f98"
      ],
      "background": "#f3f8fc",
      "grid": "#d2e1ec",
      "node": "#ffffff",
      "nodeBorder": "#54728a",
      "text": "#10263b",
      "focalNode": "#a8c6fe",
      "focalBorder": "#0d3f91",
      "coreNode": "#e5f0fa",
      "coreBorder": "#306b99",
      "detailNode": "#fbfdff",
      "detailBorder": "#7190a6",
      "labelHalo": "#f3f8fc",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "systems",
      "visualPreset": "systems",
      "name": "Systems",
      "group": "professional",
      "description": "Modern systems architecture with exaggerated hierarchy, crisp structure, and minimal canvas noise",
      "palette": [
        "#123f5a",
        "#0d766e",
        "#2c64c7",
        "#6748b5",
        "#a95d16",
        "#48616d",
        "#8a4d63"
      ],
      "background": "#f8fafb",
      "grid": "#e4e9ed",
      "node": "#ffffff",
      "nodeBorder": "#53636e",
      "text": "#17232c",
      "focalNode": "#dfeaf0",
      "focalBorder": "#123f5a",
      "coreNode": "#f0f5f7",
      "coreBorder": "#4f6f7e",
      "detailNode": "#ffffff",
      "detailBorder": "#8b969d",
      "labelHalo": "#f8fafb",
      "canvas": "dual",
      "access": "professional",
      "nodeStyle": {
        "focalRadius": 18,
        "coreRadius": 9,
        "supportingRadius": 4,
        "detailRadius": 1,
        "borderWidthScale": 1.1
      },
      "edgeStyle": {
        "widthScale": 1.08,
        "opacity": 0.9,
        "markerScale": 1.02
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 600,
        "opacity": 0.96,
        "haloPadding": 2,
        "haloOpacity": 0.96,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 28
      }
    },
    {
      "id": "atlas",
      "nodeStyle": {
        "focalRadius": 5,
        "coreRadius": 4,
        "supportingRadius": 3,
        "detailRadius": 2,
        "borderWidthScale": 0.96
      },
      "edgeStyle": {
        "widthScale": 0.92,
        "opacity": 0.84,
        "markerScale": 0.94
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 2,
        "haloOpacity": 0.94,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.1,
        "spacing": 28
      },
      "name": "Atlas",
      "group": "professional",
      "description": "Dense analytical styling for research, strategy, policy, and complex knowledge maps",
      "palette": [
        "#244b67",
        "#3e6d55",
        "#96513c",
        "#9a7624",
        "#6c527e",
        "#4c718b",
        "#696f75"
      ],
      "background": "#faf9f5",
      "grid": "#e8e5df",
      "node": "#fffefa",
      "nodeBorder": "#6c7378",
      "text": "#25292c",
      "focalNode": "#e9eceb",
      "focalBorder": "#344e5d",
      "coreNode": "#f3f3ef",
      "coreBorder": "#697476",
      "detailNode": "#fffefa",
      "detailBorder": "#929691",
      "labelHalo": "#faf9f5",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "midnight",
      "nodeStyle": {
        "focalRadius": 12,
        "coreRadius": 10,
        "supportingRadius": 8,
        "detailRadius": 6,
        "borderWidthScale": 0.92
      },
      "edgeStyle": {
        "widthScale": 0.9,
        "opacity": 0.72,
        "markerScale": 0.94
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 500,
        "opacity": 0.9,
        "haloPadding": 3,
        "haloOpacity": 0.95,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.26,
        "spacing": 20
      },
      "name": "Midnight",
      "group": "professional",
      "description": "Deep navy with restrained electric accents for screen-first maps",
      "palette": [
        "#62a8ff",
        "#4fd1c5",
        "#b58cff",
        "#ffb84d",
        "#ef6f91",
        "#7cc4d8"
      ],
      "background": "#0c1422",
      "grid": "#223047",
      "node": "#141f30",
      "nodeBorder": "#65758a",
      "text": "#f5f7fa",
      "focalNode": "#243653",
      "focalBorder": "#62a8ff",
      "coreNode": "#17263a",
      "coreBorder": "#7892ad",
      "detailNode": "#111b2a",
      "detailBorder": "#53677d",
      "labelHalo": "#0c1422",
      "canvas": "dark",
      "access": "professional"
    },
    {
      "id": "swiss",
      "visualPreset": "technical",
      "nodeStyle": {
        "focalRadius": 2,
        "coreRadius": 2,
        "supportingRadius": 1,
        "detailRadius": 0,
        "borderWidthScale": 1
      },
      "edgeStyle": {
        "widthScale": 0.86,
        "opacity": 0.8,
        "markerScale": 0.9
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 600,
        "opacity": 0.92,
        "haloPadding": 1.75,
        "haloOpacity": 0.9,
        "offset": 0
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "lines",
        "opacity": 0.12,
        "spacing": 28
      },
      "name": "Swiss",
      "group": "professional",
      "description": "Minimal black structure with red and blue information-design accents",
      "palette": [
        "#d92d20",
        "#1557b0",
        "#111111",
        "#69707a",
        "#00877a"
      ],
      "background": "#fafafa",
      "grid": "#e8e8e8",
      "node": "#ffffff",
      "nodeBorder": "#222222",
      "text": "#111111",
      "focalNode": "#f2f2f2",
      "focalBorder": "#111111",
      "coreNode": "#ffffff",
      "coreBorder": "#444444",
      "detailNode": "#ffffff",
      "detailBorder": "#777777",
      "labelHalo": "#fafafa",
      "canvas": "paper",
      "access": "professional"
    },
    {
      "id": "studio",
      "visualPreset": "studio",
      "name": "Studio",
      "group": "professional",
      "description": "Contemporary design-studio color on a clean canvas with crisp hierarchy and minimal visual noise",
      "palette": [
        "#315efb",
        "#e85d45",
        "#169b84",
        "#7857d8",
        "#d49722",
        "#c74588",
        "#48758f"
      ],
      "background": "#fafafa",
      "grid": "#e5e7e9",
      "node": "#ffffff",
      "nodeBorder": "#656b73",
      "text": "#1d2025",
      "focalNode": "#e8edff",
      "focalBorder": "#315efb",
      "coreNode": "#f4f5f7",
      "coreBorder": "#6b7280",
      "detailNode": "#ffffff",
      "detailBorder": "#90959c",
      "labelHalo": "#fafafa",
      "canvas": "dual",
      "access": "professional",
      "nodeStyle": {
        "focalRadius": 8,
        "coreRadius": 6,
        "supportingRadius": 4,
        "detailRadius": 2,
        "borderWidthScale": 0.84
      },
      "edgeStyle": {
        "widthScale": 0.84,
        "opacity": 0.76,
        "markerScale": 0.92
      },
      "relationshipLabelStyle": {
        "fontSize": 11,
        "fontWeight": 600,
        "opacity": 0.9,
        "haloPadding": 2,
        "haloOpacity": 0.9,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 26
      }
    },
    {
      "id": "cloud",
      "visualPreset": "cloud",
      "name": "Cloud",
      "group": "professional",
      "description": "Airy soft-interface styling with broad geometry and quiet contemporary color",
      "palette": [
        "#466581",
        "#6884a3",
        "#7d6cae",
        "#4f8b7d",
        "#aa7b55",
        "#8a6f87"
      ],
      "background": "#f7f9fc",
      "grid": "#e7ebf1",
      "node": "#ffffff",
      "nodeBorder": "#b8c0ca",
      "text": "#26323d",
      "focalNode": "#eef3fb",
      "focalBorder": "#6f86a3",
      "coreNode": "#f5f7fb",
      "coreBorder": "#9aa8b8",
      "detailNode": "#ffffff",
      "detailBorder": "#c4cad2",
      "labelHalo": "#f7f9fc",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "graphite",
      "visualPreset": "technical",
      "nodeStyle": {
        "focalRadius": 7,
        "coreRadius": 6,
        "supportingRadius": 4,
        "detailRadius": 3,
        "borderWidthScale": 0.9
      },
      "edgeStyle": {
        "widthScale": 0.8,
        "opacity": 0.68,
        "markerScale": 0.88
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 500,
        "opacity": 0.88,
        "haloPadding": 2.25,
        "haloOpacity": 0.94,
        "offset": 1
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.16,
        "spacing": 22
      },
      "name": "Graphite",
      "group": "professional",
      "description": "Charcoal surfaces with cool gray structure and restrained amber accents",
      "palette": [
        "#d5d9df",
        "#9ca7b4",
        "#74a4c4",
        "#d4a64f",
        "#8f83b8",
        "#77a99b"
      ],
      "background": "#1b1e23",
      "grid": "#343941",
      "node": "#262a31",
      "nodeBorder": "#7e8792",
      "text": "#f5f6f7",
      "focalNode": "#303640",
      "focalBorder": "#d4a64f",
      "coreNode": "#242a32",
      "coreBorder": "#929ba6",
      "detailNode": "#20242a",
      "detailBorder": "#646d78",
      "labelHalo": "#1b1e23",
      "canvas": "dark",
      "access": "professional"
    },
    {
      "id": "tide",
      "visualPreset": "organic",
      "nodeStyle": {
        "focalRadius": 14,
        "coreRadius": 11,
        "supportingRadius": 8,
        "detailRadius": 6,
        "borderWidthScale": 0.86
      },
      "edgeStyle": {
        "widthScale": 0.8,
        "opacity": 0.7,
        "markerScale": 0.9
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 500,
        "opacity": 0.88,
        "haloPadding": 2.75,
        "haloOpacity": 0.9,
        "offset": 2
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.12,
        "spacing": 28
      },
      "name": "Tide",
      "group": "natural",
      "description": "Spacious marine blues and sea-glass tones with light, open structure",
      "palette": [
        "#0077b6",
        "#00a6a6",
        "#2f6fed",
        "#2a9d8f",
        "#5a67d8",
        "#3ba7c9",
        "#4b887c",
        "#6f7fb8"
      ],
      "background": "#f7fcfd",
      "grid": "#dcebed",
      "node": "#ffffff",
      "nodeBorder": "#61767d",
      "text": "#16272d",
      "focalNode": "#dff5f4",
      "focalBorder": "#008b8b",
      "coreNode": "#eef9f8",
      "coreBorder": "#4a8b87",
      "detailNode": "#ffffff",
      "detailBorder": "#819397",
      "labelHalo": "#f7fcfd",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "botanical",
      "visualPreset": "organic",
      "nodeStyle": {
        "focalRadius": 18,
        "coreRadius": 15,
        "supportingRadius": 11,
        "detailRadius": 8,
        "borderWidthScale": 0.94
      },
      "edgeStyle": {
        "widthScale": 0.88,
        "opacity": 0.78,
        "markerScale": 0.94
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 500,
        "opacity": 0.9,
        "haloPadding": 3,
        "haloOpacity": 0.92,
        "offset": 2
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.16,
        "spacing": 22
      },
      "name": "Botanical",
      "group": "natural",
      "description": "Layered leaf, eucalyptus, moss, and herb tones with soft organic structure",
      "palette": [
        "#16835f",
        "#4f9d69",
        "#78a94b",
        "#2d7f73",
        "#6b8f55",
        "#3f7764",
        "#94a84d",
        "#417a8a"
      ],
      "background": "#f8fbf6",
      "grid": "#e1e9dc",
      "node": "#ffffff",
      "nodeBorder": "#667667",
      "text": "#1b2920",
      "focalNode": "#dcefd9",
      "focalBorder": "#39734b",
      "coreNode": "#eef6eb",
      "coreBorder": "#668266",
      "detailNode": "#ffffff",
      "detailBorder": "#879487",
      "labelHalo": "#f8fbf6",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "clay",
      "visualPreset": "organic",
      "nodeStyle": {
        "focalRadius": 10,
        "coreRadius": 8,
        "supportingRadius": 6,
        "detailRadius": 4,
        "borderWidthScale": 1.08
      },
      "edgeStyle": {
        "widthScale": 0.98,
        "opacity": 0.84,
        "markerScale": 0.98
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 600,
        "opacity": 0.93,
        "haloPadding": 2.5,
        "haloOpacity": 0.92,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "lines",
        "opacity": 0.1,
        "spacing": 26
      },
      "name": "Clay",
      "group": "natural",
      "description": "Warm clay, coral, mineral blue, and soft green with grounded tactile structure and substantial forms",
      "palette": [
        "#d2674f",
        "#c47a45",
        "#a84f68",
        "#397a78",
        "#4f7391",
        "#8a6a4f",
        "#75649a",
        "#bd5943"
      ],
      "background": "#fff9f5",
      "grid": "#ebddd5",
      "node": "#ffffff",
      "nodeBorder": "#7c6960",
      "text": "#302722",
      "focalNode": "#f4d9cf",
      "focalBorder": "#b9523f",
      "coreNode": "#f9ebe5",
      "coreBorder": "#b97864",
      "detailNode": "#ffffff",
      "detailBorder": "#9a8981",
      "labelHalo": "#fff9f5",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "dusk",
      "visualPreset": "studio",
      "nodeStyle": {
        "focalRadius": 12,
        "coreRadius": 9,
        "supportingRadius": 6,
        "detailRadius": 4,
        "borderWidthScale": 0.86
      },
      "edgeStyle": {
        "widthScale": 0.8,
        "opacity": 0.7,
        "markerScale": 0.9
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 500,
        "opacity": 0.9,
        "haloPadding": 3,
        "haloOpacity": 0.94,
        "offset": 2
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 30
      },
      "name": "Dusk",
      "group": "natural",
      "description": "Smoky twilight mauve, blue-gray, rust, and sage on a quiet warm-gray field",
      "palette": [
        "#665f82",
        "#6d7889",
        "#92646a",
        "#52766f",
        "#9a7655",
        "#705b73",
        "#7f6d72",
        "#5d7982"
      ],
      "background": "#f3efed",
      "grid": "#ded8d5",
      "node": "#fbf9f8",
      "nodeBorder": "#7b7377",
      "text": "#2c292d",
      "focalNode": "#e7d9dc",
      "focalBorder": "#7d5e68",
      "coreNode": "#eee8e7",
      "coreBorder": "#7c7478",
      "detailNode": "#fbf9f8",
      "detailBorder": "#999194",
      "labelHalo": "#f3efed",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "mineral",
      "visualPreset": "studio",
      "nodeStyle": {
        "focalRadius": 7,
        "coreRadius": 5,
        "supportingRadius": 3,
        "detailRadius": 2,
        "borderWidthScale": 0.96
      },
      "edgeStyle": {
        "widthScale": 0.86,
        "opacity": 0.74,
        "markerScale": 0.92
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 500,
        "opacity": 0.9,
        "haloPadding": 2,
        "haloOpacity": 0.9,
        "offset": 1
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "lines",
        "opacity": 0.12,
        "spacing": 28
      },
      "name": "Mineral",
      "group": "natural",
      "description": "Slate, quartz, turquoise, iron, and ochre with angular, subdued structure",
      "palette": [
        "#436b78",
        "#397f79",
        "#8b6656",
        "#a57a32",
        "#665f86",
        "#50718d",
        "#8b5260",
        "#66776a"
      ],
      "background": "#f8f8f6",
      "grid": "#e2e2de",
      "node": "#ffffff",
      "nodeBorder": "#70726f",
      "text": "#262825",
      "focalNode": "#e5eceb",
      "focalBorder": "#456b68",
      "coreNode": "#f1f3f1",
      "coreBorder": "#717b77",
      "detailNode": "#ffffff",
      "detailBorder": "#929591",
      "labelHalo": "#f8f8f6",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "solar",
      "visualPreset": "graphic",
      "nodeStyle": {
        "focalRadius": 9,
        "coreRadius": 7,
        "supportingRadius": 5,
        "detailRadius": 4,
        "borderWidthScale": 1.02
      },
      "edgeStyle": {
        "widthScale": 1.04,
        "opacity": 0.86,
        "markerScale": 1
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 2.75,
        "haloOpacity": 0.92,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.14,
        "spacing": 24
      },
      "name": "Solar",
      "group": "natural",
      "description": "Sunlit yellow, coral, orange, violet, and sky on a warm pale field",
      "palette": [
        "#c88a00",
        "#e2673f",
        "#d54661",
        "#6d5cc4",
        "#3687b7",
        "#56935a",
        "#b2648e",
        "#b66a19"
      ],
      "background": "#fffaf0",
      "grid": "#eee1c9",
      "node": "#fffefa",
      "nodeBorder": "#756d5d",
      "text": "#30291f",
      "focalNode": "#ffe9a8",
      "focalBorder": "#ad7500",
      "coreNode": "#fff4d3",
      "coreBorder": "#a98545",
      "detailNode": "#fffefa",
      "detailBorder": "#9a9386",
      "labelHalo": "#fffaf0",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "glacier",
      "nodeStyle": {
        "focalRadius": 6,
        "coreRadius": 4,
        "supportingRadius": 3,
        "detailRadius": 1,
        "borderWidthScale": 0.88
      },
      "edgeStyle": {
        "widthScale": 0.76,
        "opacity": 0.74,
        "markerScale": 0.9
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 500,
        "opacity": 0.92,
        "haloPadding": 1.75,
        "haloOpacity": 0.92,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "cross",
        "opacity": 0.1,
        "spacing": 28
      },
      "name": "Glacier",
      "group": "natural",
      "description": "Crisp ice, mineral blue, turquoise, and stone with sparse crystalline structure",
      "palette": [
        "#426d86",
        "#4c8991",
        "#687b9e",
        "#598677",
        "#77718f",
        "#71828b",
        "#4d7f9a"
      ],
      "background": "#f5f9fb",
      "grid": "#dce7ec",
      "node": "#ffffff",
      "nodeBorder": "#71818b",
      "text": "#1f303a",
      "focalNode": "#dfeaf0",
      "focalBorder": "#426d86",
      "coreNode": "#edf4f7",
      "coreBorder": "#6e8794",
      "detailNode": "#ffffff",
      "detailBorder": "#98a5ac",
      "labelHalo": "#f5f9fb",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "desert",
      "nodeStyle": {
        "focalRadius": 5,
        "coreRadius": 4,
        "supportingRadius": 2,
        "detailRadius": 1,
        "borderWidthScale": 0.88
      },
      "edgeStyle": {
        "widthScale": 0.76,
        "opacity": 0.72,
        "markerScale": 0.88
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 500,
        "opacity": 0.9,
        "haloPadding": 1.75,
        "haloOpacity": 0.9,
        "offset": 1
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 30
      },
      "name": "Desert",
      "group": "natural",
      "description": "Muted sand, adobe, cactus, indigo, and sage with sparse architectural structure and wide visual quiet",
      "palette": [
        "#9b6a36",
        "#ae5841",
        "#5d7155",
        "#53627d",
        "#8d7051",
        "#7b5964",
        "#6a7b68"
      ],
      "background": "#f8f1e6",
      "grid": "#e6d8c4",
      "node": "#fffaf2",
      "nodeBorder": "#817567",
      "text": "#302920",
      "focalNode": "#e9d3b7",
      "focalBorder": "#8f6137",
      "coreNode": "#f3e6d4",
      "coreBorder": "#8b7763",
      "detailNode": "#fffaf2",
      "detailBorder": "#9f9385",
      "labelHalo": "#f8f1e6",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "wildflower",
      "nodeStyle": {
        "focalRadius": 20,
        "coreRadius": 15,
        "supportingRadius": 10,
        "detailRadius": 6,
        "borderWidthScale": 0.66
      },
      "edgeStyle": {
        "widthScale": 0.7,
        "opacity": 0.62,
        "markerScale": 0.84
      },
      "relationshipLabelStyle": {
        "fontSize": 11,
        "fontWeight": 500,
        "opacity": 0.86,
        "haloPadding": 3.5,
        "haloOpacity": 0.9,
        "offset": 3
      },
      "typography": {
        "focalWeight": 700,
        "coreWeight": 600,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 30
      },
      "name": "Wildflower",
      "group": "natural",
      "description": "Sage, cornflower, violet, ochre, rose, and terracotta with exceptionally soft, delicate open structure",
      "palette": [
        "#6f8b63",
        "#5e78a5",
        "#7d6f9a",
        "#a17e35",
        "#a96772",
        "#5e806f",
        "#a66b52"
      ],
      "background": "#fbf8f3",
      "grid": "#e8e1d8",
      "node": "#fffdf9",
      "nodeBorder": "#aaa39a",
      "text": "#302d29",
      "focalNode": "#eee8e2",
      "focalBorder": "#9b817b",
      "coreNode": "#f6f2ed",
      "coreBorder": "#a79d96",
      "detailNode": "#fffdf9",
      "detailBorder": "#b7b0a9",
      "labelHalo": "#fbf8f3",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "citrus",
      "visualPreset": "playful",
      "nodeStyle": {
        "focalRadius": 13,
        "coreRadius": 10,
        "supportingRadius": 7,
        "detailRadius": 5,
        "borderWidthScale": 1.1
      },
      "edgeStyle": {
        "widthScale": 1.12,
        "opacity": 0.9,
        "markerScale": 1.04
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 600,
        "opacity": 0.96,
        "haloPadding": 2.75,
        "haloOpacity": 0.94,
        "offset": 1
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "cross",
        "opacity": 0.16,
        "spacing": 22
      },
      "name": "Citrus",
      "group": "playful",
      "description": "Acid green, orange, teal, berry, and violet with crisp energetic structure",
      "palette": [
        "#397300",
        "#c14f08",
        "#007f6d",
        "#b51f55",
        "#6541c7",
        "#9a7200",
        "#007599",
        "#aa4618"
      ],
      "background": "#fffdf1",
      "grid": "#e8e2bd",
      "node": "#fffef9",
      "nodeBorder": "#646842",
      "text": "#292b18",
      "focalNode": "#ddf08d",
      "focalBorder": "#557000",
      "coreNode": "#f2f6c8",
      "coreBorder": "#78832c",
      "detailNode": "#fffef9",
      "detailBorder": "#858766",
      "labelHalo": "#fffdf1",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "candy",
      "nodeStyle": {
        "focalRadius": 20,
        "coreRadius": 17,
        "supportingRadius": 13,
        "detailRadius": 10,
        "borderWidthScale": 1.02
      },
      "edgeStyle": {
        "widthScale": 1.06,
        "opacity": 0.84,
        "markerScale": 0.98
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 0.92,
        "haloPadding": 3.5,
        "haloOpacity": 0.94,
        "offset": 3
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.2,
        "spacing": 22
      },
      "name": "Candy",
      "group": "playful",
      "description": "Bubblegum pink, grape, sky blue, mint, and tangerine with buoyant rounded structure",
      "palette": [
        "#ef4f9a",
        "#7857e8",
        "#238bd3",
        "#00a88f",
        "#f16f4b",
        "#e6a61f",
        "#c747c9",
        "#3c8090"
      ],
      "background": "#fff8fc",
      "grid": "#eedce8",
      "node": "#ffffff",
      "nodeBorder": "#75566a",
      "text": "#321d2b",
      "focalNode": "#ffd8eb",
      "focalBorder": "#d93680",
      "coreNode": "#f6e8ff",
      "coreBorder": "#8157c5",
      "detailNode": "#ffffff",
      "detailBorder": "#9b7f90",
      "labelHalo": "#fff8fc",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "tropical",
      "visualPreset": "organic",
      "nodeStyle": {
        "focalRadius": 17,
        "coreRadius": 13,
        "supportingRadius": 9,
        "detailRadius": 6,
        "borderWidthScale": 1
      },
      "edgeStyle": {
        "widthScale": 1.02,
        "opacity": 0.86,
        "markerScale": 1
      },
      "relationshipLabelStyle": {
        "fontSize": 12,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 3,
        "haloOpacity": 0.94,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.14,
        "spacing": 26
      },
      "name": "Tropical",
      "group": "playful",
      "description": "Lagoon, coral, orchid, citrus, and leaf colors with lush rounded energy",
      "palette": [
        "#008a79",
        "#ed5b6f",
        "#7647d8",
        "#e18019",
        "#168cae",
        "#5c9427",
        "#bd32b4",
        "#dc5428"
      ],
      "background": "#f1fcf8",
      "grid": "#cdebe0",
      "node": "#fcfffd",
      "nodeBorder": "#43756b",
      "text": "#143b34",
      "focalNode": "#ffe69b",
      "focalBorder": "#be6900",
      "coreNode": "#dff6ed",
      "coreBorder": "#34826e",
      "detailNode": "#fcfffd",
      "detailBorder": "#71958d",
      "labelHalo": "#f1fcf8",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "blocks",
      "nodeStyle": {
        "focalRadius": 2,
        "coreRadius": 2,
        "supportingRadius": 1,
        "detailRadius": 0,
        "borderWidthScale": 1.12
      },
      "edgeStyle": {
        "widthScale": 1.08,
        "opacity": 0.9,
        "markerScale": 1.02
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 600,
        "opacity": 0.95,
        "haloPadding": 2.5,
        "haloOpacity": 0.94,
        "offset": 0
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "lines",
        "opacity": 0.1,
        "spacing": 26
      },
      "name": "Blocks",
      "group": "playful",
      "description": "Bright modular color with crisp block geometry and clean graphic structure",
      "palette": [
        "#3467d6",
        "#e05e45",
        "#c69a21",
        "#2b9277",
        "#7653c2",
        "#d44f88",
        "#238ba1"
      ],
      "background": "#fffdf8",
      "grid": "#ece7dd",
      "node": "#ffffff",
      "nodeBorder": "#5d5c60",
      "text": "#242326",
      "focalNode": "#f7df9e",
      "focalBorder": "#9d7420",
      "coreNode": "#f8f5ee",
      "coreBorder": "#6f6a62",
      "detailNode": "#ffffff",
      "detailBorder": "#8b8780",
      "labelHalo": "#fffdf8",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "firefly",
      "nodeStyle": {
        "focalRadius": 16,
        "coreRadius": 13,
        "supportingRadius": 10,
        "detailRadius": 7,
        "borderWidthScale": 0.9
      },
      "edgeStyle": {
        "widthScale": 0.9,
        "opacity": 0.78,
        "markerScale": 0.94
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 3.25,
        "haloOpacity": 0.96,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 500
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.14,
        "spacing": 28
      },
      "name": "Firefly",
      "group": "playful",
      "description": "Warm nocturnal color with soft rounded forms and gentle luminous accents",
      "palette": [
        "#f0c84b",
        "#75c69d",
        "#e77b68",
        "#74aee8",
        "#b493df",
        "#a8c965",
        "#e7a36f"
      ],
      "background": "#10201f",
      "grid": "#29403d",
      "node": "#1a2b29",
      "nodeBorder": "#728984",
      "text": "#f6f5ed",
      "focalNode": "#2d3b2d",
      "focalBorder": "#f0c84b",
      "coreNode": "#1f302d",
      "coreBorder": "#75c69d",
      "detailNode": "#172624",
      "detailBorder": "#5f7772",
      "labelHalo": "#10201f",
      "canvas": "dark",
      "access": "professional"
    },
    {
      "id": "arcade",
      "visualPreset": "arcade",
      "name": "Arcade",
      "group": "playful",
      "description": "Digital primary colors on deep charcoal with crisp screen-grid structure",
      "palette": [
        "#34d8ff",
        "#ff4b6e",
        "#75e85b",
        "#ffd33d",
        "#8075ff",
        "#ff7a35",
        "#ef5ee0",
        "#39d6b0"
      ],
      "background": "#16181d",
      "grid": "#30343d",
      "node": "#22262e",
      "nodeBorder": "#8b94a3",
      "text": "#f7f8fa",
      "focalNode": "#2b3140",
      "focalBorder": "#34d8ff",
      "coreNode": "#202832",
      "coreBorder": "#8075ff",
      "detailNode": "#1d2128",
      "detailBorder": "#68717e",
      "labelHalo": "#16181d",
      "canvas": "dark",
      "access": "professional"
    },
    {
      "id": "orbit",
      "nodeStyle": {
        "focalRadius": 22,
        "coreRadius": 12,
        "supportingRadius": 6,
        "detailRadius": 2,
        "borderWidthScale": 0.9
      },
      "edgeStyle": {
        "widthScale": 0.94,
        "opacity": 0.82,
        "markerScale": 0.96
      },
      "relationshipLabelStyle": {
        "fontSize": 11.5,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 2.75,
        "haloOpacity": 0.94,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 600,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.12,
        "spacing": 30
      },
      "name": "Orbit",
      "group": "playful",
      "description": "Exaggerated hierarchy and cool contemporary color for playful science and concept maps",
      "palette": [
        "#4567d8",
        "#6f4fc4",
        "#178b90",
        "#cf5c58",
        "#9c8a24",
        "#5b9b67",
        "#b54e8a"
      ],
      "background": "#f7f8fd",
      "grid": "#e2e6f2",
      "node": "#ffffff",
      "nodeBorder": "#747c92",
      "text": "#202433",
      "focalNode": "#e3e8fb",
      "focalBorder": "#4567d8",
      "coreNode": "#eef1fb",
      "coreBorder": "#777fa0",
      "detailNode": "#ffffff",
      "detailBorder": "#9aa0ae",
      "labelHalo": "#f7f8fd",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "punch",
      "nodeStyle": {
        "focalRadius": 4,
        "coreRadius": 3,
        "supportingRadius": 2,
        "detailRadius": 1,
        "borderWidthScale": 0.98
      },
      "edgeStyle": {
        "widthScale": 0.88,
        "opacity": 0.82,
        "markerScale": 0.94
      },
      "relationshipLabelStyle": {
        "fontSize": 10.5,
        "fontWeight": 600,
        "opacity": 0.94,
        "haloPadding": 2,
        "haloOpacity": 0.94,
        "offset": 0
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 800,
        "supportingWeight": 600,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "none",
        "opacity": 0,
        "spacing": 28
      },
      "name": "Punch",
      "group": "playful",
      "description": "Typography-driven playful styling with bold hierarchy, compact geometry, and controlled contemporary color",
      "palette": [
        "#2f5fd3",
        "#d04c4c",
        "#12856e",
        "#bd861d",
        "#7550b8",
        "#c3447f",
        "#237f96"
      ],
      "background": "#fffdfb",
      "grid": "#ece9e5",
      "node": "#ffffff",
      "nodeBorder": "#5e6268",
      "text": "#202226",
      "focalNode": "#eef1f7",
      "focalBorder": "#354e73",
      "coreNode": "#f8f8f6",
      "coreBorder": "#6d737a",
      "detailNode": "#ffffff",
      "detailBorder": "#92979c",
      "labelHalo": "#fffdfb",
      "canvas": "dual",
      "access": "professional"
    },
    {
      "id": "kite",
      "nodeStyle": {
        "focalRadius": 6,
        "coreRadius": 4,
        "supportingRadius": 2,
        "detailRadius": 0,
        "borderWidthScale": 0.72
      },
      "edgeStyle": {
        "widthScale": 0.72,
        "opacity": 0.74,
        "markerScale": 0.86
      },
      "relationshipLabelStyle": {
        "fontSize": 11,
        "fontWeight": 500,
        "opacity": 0.9,
        "haloPadding": 2.75,
        "haloOpacity": 0.92,
        "offset": 2
      },
      "typography": {
        "focalWeight": 800,
        "coreWeight": 700,
        "supportingWeight": 500,
        "detailWeight": 400
      },
      "gridStyle": {
        "type": "dots",
        "opacity": 0.06,
        "spacing": 30
      },
      "name": "Kite",
      "group": "playful",
      "description": "Airy sky-bright color with crisp lightweight geometry, fine edges, and generous visual space",
      "palette": [
        "#4b86c5",
        "#d9684c",
        "#c89a25",
        "#2f8f82",
        "#7761b8",
        "#649b55",
        "#c65f86"
      ],
      "background": "#f6fbfd",
      "grid": "#dfecef",
      "node": "#ffffff",
      "nodeBorder": "#8aa0a8",
      "text": "#223137",
      "focalNode": "#e4f0f4",
      "focalBorder": "#4b86c5",
      "coreNode": "#f0f7f8",
      "coreBorder": "#77959f",
      "detailNode": "#ffffff",
      "detailBorder": "#a4b3b8",
      "labelHalo": "#f6fbfd",
      "canvas": "dual",
      "access": "professional"
    }
  ]
}